<template>
  <div>
    <div class="container">
      <gl-switch v-model="allCustomers">全顧客</gl-switch>
      <gl-sub-text>または</gl-sub-text>
      <a class="file-input-link" href="#" @click.prevent="$refs.file.click()"
        >ファイル読込</a
      >
      <input
        type="file"
        ref="file"
        hidden
        accept=".txt,.csv"
        @change="setFile($event.target.files)"
      />
      <transition>
        <div v-if="file">
          <span class="filename">{{ filename }}</span>
        </div>
      </transition>
    </div>
    <gl-sub-text v-if="customerGroupId">
      ※ 顧客の絞込が適用されています
    </gl-sub-text>
  </div>
</template>

<script>
/**
 * 顧客グループ（顧客一覧）選択コンポーネント
 */
export default {
  props: {
    /**
     * 選択ファイル
     *
     * 実際、分析条件を復元するときにファイルを復元することはできないので、
     * このコンポーネントで選択されたファイルを親コンポーネントに連携する目的で
     * propsにFile型として定義しています。
     */
    file: {
      type: File,
    },
    /**
     * サーバーサイドで保存している一時顧客グループの識別子
     */
    customerGroupId: {
      type: String,
    },
  },
  computed: {
    allCustomers: {
      get() {
        return !(this.file || this.customerGroupId)
      },
      set(checked) {
        if (checked) {
          // 全顧客チェックはファイル入力/顧客選択なしを意味する
          this.$emit('update:file', undefined)
          this.$emit('update:customerGroupId', undefined)
        } else {
          // 全顧客チェックを外すということは、ファイル選択が必須
          this.$refs.file.click()
        }
      },
    },
    filename() {
      if (!this.file) {
        return ''
      }
      return this.file.name
    },
  },
  methods: {
    setFile(files) {
      if (files.length === 0) {
        return
      }
      this.$emit('update:file', files[0])
      this.$emit('update:customerGroupId', undefined)
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  align-items: center;
}

.filename {
  font-size: var(--font-size-large);
  margin-left: var(--spacing-medium);
}
.file-attributes {
  font-size: var(--font-size-small);
}
.size {
  margin-left: var(--spacing-small);
}

.file-input-link {
  margin-left: var(--spacing-medium);
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s, transform 0.3s;
}
.v-enter,
.v-leave-to {
  opacity: 0;
  transform: translateX(-100%);
}
</style>
